import { render, staticRenderFns } from "./RoleView.vue?vue&type=template&id=9051c5c0&scoped=true"
import script from "./RoleView.vue?vue&type=script&lang=js"
export * from "./RoleView.vue?vue&type=script&lang=js"
import style0 from "./RoleView.vue?vue&type=style&index=0&id=9051c5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9051c5c0",
  null
  
)

export default component.exports